var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "formSearch",
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "postcodeType-class",
                              attrs: {
                                placeholder: _vm.$t(
                                  "orderDetails.pleaseChoose"
                                ),
                              },
                              on: { change: _vm.clearNameCode },
                              model: {
                                value: _vm.siteChangeType,
                                callback: function ($$v) {
                                  _vm.siteChangeType = $$v
                                },
                                expression: "siteChangeType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("collectionCenter.siteName"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("collectionCenter.siteNum"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.siteChangeType === 1
                            ? _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseInput"
                                  ),
                                },
                                on: {
                                  input: _vm.changeSite,
                                  blur: function ($event) {
                                    return _vm.siteBlur("name")
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "name", $$v)
                                  },
                                  expression: "queryForm.name",
                                },
                              })
                            : _vm._e(),
                          _vm.siteChangeType === 2
                            ? _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "collectionCenter.pleaseInput"
                                  ),
                                },
                                on: {
                                  input: _vm.changeSite,
                                  blur: function ($event) {
                                    return _vm.siteBlur("code")
                                  },
                                },
                                model: {
                                  value: _vm.queryForm.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryForm, "code", $$v)
                                  },
                                  expression: "queryForm.code",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.stateZT") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.siteStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "siteStatus", $$v)
                                },
                                expression: "queryForm.siteStatus",
                              },
                            },
                            _vm._l(_vm.StatusList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.siteStatusName,
                                  value: item.siteStatus,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessModel"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.businessModel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "businessModel", $$v)
                                },
                                expression: "queryForm.businessModel",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.directSales"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.joinSales"),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.exclusive"),
                                  value: 3,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.dotType") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.siteType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "siteType", $$v)
                                },
                                expression: "queryForm.siteType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.tudo"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.hut"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.dot"),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.transferCenter"
                                  ),
                                  value: 3,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.headOffice"),
                                  value: 4,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.contractSigned"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.contractSigned,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "contractSigned", $$v)
                                },
                                expression: "queryForm.contractSigned",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.yes"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.No"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.region") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.queryForm.regionIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "regionIds", $$v)
                                },
                                expression: "queryForm.regionIds",
                              },
                            },
                            _vm._l(_vm.regionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.zhName + "（" + item.puName + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.stateSite1"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "multiple-limit": 50,
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.queryForm.stateList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "stateList", $$v)
                                },
                                expression: "queryForm.stateList",
                              },
                            },
                            _vm._l(_vm.StateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.owningTransitCenter1"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.departmentId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "departmentId", $$v)
                                },
                                expression: "queryForm.departmentId",
                              },
                            },
                            _vm._l(_vm.departmentList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.citySite") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "formTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                "remote-method": _vm.getSenderCity,
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                multiple: "",
                                "multiple-limit": 50,
                                "collapse-tags": "",
                              },
                              on: {
                                "visible-change": function ($event) {
                                  return _vm.getSenderCity()
                                },
                              },
                              model: {
                                value: _vm.queryForm.cityList,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "cityList", $$v)
                                },
                                expression: "queryForm.cityList",
                              },
                            },
                            _vm._l(_vm.cityList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.name },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "postcodeType-class",
                              attrs: {
                                placeholder: _vm.$t(
                                  "orderDetails.pleaseChoose"
                                ),
                              },
                              on: { change: _vm.postcodeTypeChange },
                              model: {
                                value: _vm.postcodeType,
                                callback: function ($$v) {
                                  _vm.postcodeType = $$v
                                },
                                expression: "postcodeType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.smallParcelPostcode"
                                  ),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.largeParcelPostcode"
                                  ),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.smallParcelCollectionPostcode"
                                  ),
                                  value: 3,
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                            },
                            on: { input: _vm.handleChangePostCode },
                            model: {
                              value: _vm.postCode,
                              callback: function ($$v) {
                                _vm.postCode = $$v
                              },
                              expression: "postCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.searchResources(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh-left",
                            size: "small",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.searchResources(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("operationCenter.reset")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.exportDateDimension },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.allExport")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.newSiteBtn },
                        },
                        [_vm._v(_vm._s(_vm.$t("collectionCenter.add")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.activeNameTab,
            callback: function ($$v) {
              _vm.activeNameTab = $$v
            },
            expression: "activeNameTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("collectionCenter.lanshou"),
                name: "lanshou",
              },
            },
            [
              _c(
                "virtual-scroll",
                {
                  ref: "virtualScroll",
                  attrs: {
                    data: _vm.tableData,
                    "item-size": 76,
                    "key-prop": "id",
                  },
                  on: {
                    change: function (virtualList) {
                      return (_vm.list = virtualList)
                    },
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.list,
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        "tree-props": {
                          children: "children",
                          hasChildren: "hasChildren",
                        },
                        "row-key": "id",
                        stripe: "",
                        height: "600",
                      },
                    },
                    [
                      _c("virtual-column", {
                        attrs: {
                          "min-width": "220",
                          type: "tree",
                          label: _vm.$t("userManage.realName"),
                          prop: "name",
                        },
                      }),
                      _vm._l(_vm.headerList, function (item, ind) {
                        return _c(
                          "el-table-column",
                          {
                            key: ind,
                            attrs: {
                              align: item.align,
                              "min-width": item.width,
                              prop: item.prop,
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      item.prop === "status"
                                        ? _c(
                                            "div",
                                            [
                                              scope.row.status === 1
                                                ? _c("el-tag", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.statusName
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : scope.row.status === 0
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: { type: "danger" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.statusName
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c("span"),
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row[item.prop] || ""
                                                ) +
                                                " "
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [_vm._v(_vm._s(item.label))]
                              ),
                            ]),
                          ],
                          2
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          fixed: "right",
                          label: _vm.$t("collectionCenter.operation"),
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.createTime
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDetial(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("basicData.View"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editSite(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("GlobalSetObj.edit")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("collectionCenter.expressDelivery"),
                name: "kuaidi",
              },
            },
            [
              _c(
                "virtual-scroll",
                {
                  ref: "virtualScroll",
                  attrs: {
                    data: _vm.tableData,
                    "item-size": 76,
                    "key-prop": "id",
                  },
                  on: {
                    change: function (virtualList) {
                      return (_vm.list = virtualList)
                    },
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.list,
                        "header-cell-style": {
                          background: "#f2f2f2",
                          color: "black",
                        },
                        "tree-props": {
                          children: "children",
                          hasChildren: "hasChildren",
                        },
                        "row-key": "id",
                        stripe: "",
                        height: "600px",
                      },
                    },
                    [
                      _c("virtual-column", {
                        attrs: {
                          "min-width": "220",
                          type: "tree",
                          label: _vm.$t("userManage.realName"),
                          prop: "name",
                        },
                      }),
                      _vm._l(_vm.headerList, function (item, ind) {
                        return _c(
                          "el-table-column",
                          {
                            key: ind,
                            attrs: {
                              align: item.align,
                              "min-width": item.width,
                              prop: item.prop,
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      item.prop === "status"
                                        ? _c(
                                            "div",
                                            [
                                              scope.row.status === 1
                                                ? _c("el-tag", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          scope.row.statusName
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : scope.row.status === 0
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: { type: "danger" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.statusName
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c("span"),
                                            ],
                                            1
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row[item.prop] || ""
                                                ) +
                                                " "
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _c("div", [_vm._v(_vm._s(item.label))]),
                            ]),
                          ],
                          2
                        )
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: _vm.$t("collectionCenter.operation"),
                          width: "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.createTime
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.seeDetial(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("basicData.View"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editSite(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("GlobalSetObj.edit")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("new-site", { ref: "newSiteRef", on: { reSearch: _vm.reSearch } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }